import {Root} from '@radix-ui/react-separator'
import styled from 'styled-components'

export const Separator = styled(Root)`
  height: 1px;
  background-color: var(--color-border);
`
